import { PageService } from './page.service';

export class Page {
  public uid: any;
  public subject: string;
  public content: string = "";
  public chapter: string = "";
  public hidden: number = 0;
  
  //public constructor(init?:Partial<Page>) {
  //  Object.assign(this, init);
  //}
    
  public constructor(
	fields?: {
		uid?: any, 
		subject?: string,
		content?: string,
		hidden?: number
	}) 
  {
        if (fields) {
			this.uid = fields.uid || "0";
			this.subject = fields.subject || "";
			this.content = fields.content || "";
			this.hidden = fields.hidden || 0; 
		}
  }
  
  public getSubjectStripped(): string {
	  var regex = /(\[.*\])/; 
	  
	  if(this.subject == null) return '';
	  
	  //console.log(this.subject);
	  
	  return this.subject.replace(regex, '');
  }
  
  public zeropad(n, width, z): string {
      z = z || '0';
	  n = n + '';
	  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }  
  
  public alertHidden() {
	alert(
        "본 '천지의 도, 춘생추살' 가이드북에서는 일부 항목이 가려져 있습니다.\n"+
        "가까운 도장에 문의바랍니다. 시중 서점에서도 구하실 수 있습니다."); 
  }
  
}
